/**
 * Increase Product Quantity Action
 * Triggered by: arc:action:quantityIncrease
 */

export const runQuantityIncrease = async (data = {}) => {
    try {
        const { 
            step = 1, 
            maxQuantity = null,
            targetSelector = "[data-prodify-quantity-presentation]",
            autoUpdatePrice = true 
        } = data;

        const quantityInput = document.querySelector(targetSelector);
        
        if (!quantityInput) {
            throw new Error(`Quantity input not found with selector: ${targetSelector}`);
        }

        const currentValue = parseInt(quantityInput.value) || 0;
        let newValue = currentValue + step;

        // Check maximum quantity limit
        if (maxQuantity && newValue > maxQuantity) {
            newValue = maxQuantity;
            
            // Dispatch max quantity reached event
            window.dispatchEvent(new CustomEvent('quantity:maxReached', {
                detail: {
                    maxQuantity,
                    attemptedValue: currentValue + step
                }
            }));
        }

        // Update the display input
        quantityInput.value = newValue;

        // Update form inputs and pricing
        if (autoUpdatePrice) {
            await updateFormInputValue(newValue);
        }

        // Dispatch quantity changed event
        window.dispatchEvent(new CustomEvent('quantity:changed', {
            detail: {
                oldValue: currentValue,
                newValue: newValue,
                action: 'increase',
                step: step
            }
        }));

        return {
            success: true,
            oldValue: currentValue,
            newValue: newValue,
            step: step,
            message: 'Quantity increased successfully'
        };

    } catch (error) {
        console.error('Quantity Increase error:', error);
        
        window.dispatchEvent(new CustomEvent('quantity:error', {
            detail: {
                error: error.message,
                action: 'increase'
            }
        }));

        return {
            success: false,
            error: error.message
        };
    }
};

// Helper function to update form inputs and pricing
const updateFormInputValue = async (quantity) => {
    // Update all product form quantity inputs
    const productForms = document.querySelectorAll(".pdp-details .product-form input[name='quantity']");
    
    productForms.forEach((productFormInput) => {
        productFormInput.value = quantity;
    });

    // Update add to cart button with new pricing
    const currencySymbol = window.Alpine?.store('currency')?.getCurrencySymbol() || '$';
    
    // Get base price from global state or calculate from current variant
    let basePrice = window.selectedBasePrice || 0;
    
    if (!basePrice) {
        // Try to get price from current variant
        const currentVariant = window.currentVariant;
        if (currentVariant) {
            const variantElement = document.querySelector(`input[data-variant-id="${currentVariant}"]`);
            const variantPrice = variantElement?.getAttribute("data-variant-price");
            if (variantPrice) {
                basePrice = parseFloat(variantPrice.replace("$", ""));
            }
        }
    }

    if (basePrice > 0) {
        const totalPrice = basePrice * quantity;
        
        // Dispatch event to update add button
        window.dispatchEvent(new CustomEvent('addButton:update', {
            detail: {
                disabled: false,
                text: `Add to Cart | ${currencySymbol}${totalPrice.toFixed(2)}`,
                modifyClass: false,
                price: basePrice
            }
        }));
    }
};

export default runQuantityIncrease;
